import { createClient, fetchExchange } from '@urql/core';
import { registerUrql } from '@urql/next/rsc';
import { initGraphQLTada } from 'gql.tada';

import { env } from '@/env';
import type { introspection } from '@/utils/gql-tada/graphql-env.d.ts';

export const graphql = initGraphQLTada<{
  introspection: introspection;
  scalars: {
    Date: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    JSON: any;
  };
}>();
export { readFragment } from 'gql.tada';
export type { FragmentOf, ResultOf, VariablesOf } from 'gql.tada';

function makeClient() {
  const url = new URL('/graphql', env.API_BASE_URL);

  const client = createClient({
    url: url.toString(),
    exchanges: [fetchExchange],
    fetchOptions: () => {
      return {
        headers: { Authorization: `Bearer ${env.API_AUTH_TOKEN}` },
      };
    },
  });

  return client;
}

export const { getClient } = registerUrql(makeClient);
